<template>
  <CurationRenderer :curation="cur" :show-edit="showEdit" @edit="edit()" />
</template>

<script lang="ts" setup>
definePageMeta({
  qsearch: true,
  pageTransition: {
    name: 'slide-page-right',
    mode: 'out-in',
  },
  middleware(to, from) {
    if (to.meta.pageTransition && typeof to.meta.pageTransition !== 'boolean') {
      let pageFrom = Number(from.params.page || 0)
      let pageTo = Number(to.params.page || 0)
      if (pageFrom < pageTo) {
        to.meta.pageTransition.name = 'slide-page-right'
      } else {
        to.meta.pageTransition.name = 'slide-page-left'
      }
    }
  },
})

const { getPageAndCache } = usePage()
const { meta } = await getPageAndCache()
useHead(meta)

const { langPath } = useI18n()
const route = useRoute()
const router = useRouter()
const dataStore = useDataStore()
const userStore = useUserStore()

const cur = computed(() => {
  return dataStore.curation(route.params.curId as string)
})

const showEdit = computed(() => {
  return cur.value && userStore.hasEditForData(cur.value)
})

const edit = () => {
  router.push(langPath(`/management/gallery/${cur.value.id}`))
}
</script>

<style lang="scss" scoped>
</style>
